// extracted by mini-css-extract-plugin
export default {"wrapper":"no-documentation_wrapper__B2sEL"};